import type { ReadonlyDeep } from 'type-fest';

export function deepFreeze<T>(o: T) {
  if (typeof o === 'object' && o !== null) {
    Object.values(o).forEach(v => Object.isFrozen(v) || deepFreeze(v));
  }

  return Object.freeze(o) as ReadonlyDeep<T>;
}

/**
 * Safely clone objects that may contain non-serializable properties
 * Falls back to shallow copy if deep cloning fails
 */
export function safeClone<T>(obj: T): T {
  if (obj === null || obj === undefined) {
    return obj;
  }

  try {
    // Try structuredClone first (most reliable for modern browsers)
    return structuredClone(obj);
  } catch (error) {
    try {
      // Fallback to JSON serialization (handles most OpenAPI properties)
      return JSON.parse(JSON.stringify(obj));
    } catch (jsonError) {
      // Final fallback to shallow copy
      if (Array.isArray(obj)) {
        return [...obj] as T;
      }
      if (typeof obj === 'object') {
        return { ...obj } as T;
      }
      return obj;
    }
  }
}
